import './App.css';
import Book from './Pages/Book/Book';
import RotateSc from './Pages/RotateSc';

function App() {
  return (
    <div>
    <RotateSc />
    </div>
    
  );
}

export default App;
